<template>
  <checkbox-tree
    :version="dsComponentDetails.version"
    :filter="filter"
    :value="currentValue"
    @update:value="updateValue($event)"
  />
</template>

<script>
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';
import CheckboxTree from '@src/components/Filter/components/collapsable/CheckboxTree.vue';

export default {
  name: 'CheckboxTreeHandler',
  components: {
    CheckboxTree,
  },
  mixins: [versionedComponentsMixin],
  props: {
    filterValue: {
      type: Object,
      required: true,
      default: () => {},
    },
    filter: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  emits: ['update:filter-value'],
  data() {
    return {
      currentValue: [],
    };
  },
  watch: {
    'filterValue.value': function (newValue) {
      this.currentValue = (newValue || []);
    },
  },
  mounted() {
    this.currentValue = (this.filterValue?.value || []);
  },
  methods: {

    updateValue(value) {
      const checks = this.currentValue.filter((curr) => curr.checked).reduce((prev, curr) => {
        const previous = prev;
        previous[curr.key] = curr;
        return previous;
      }, {});
      value.forEach((item) => {
        const record = item;
        if (record.checked) {
          checks[record.key] = record;
        } else {
          delete checks[record.key];
        }
      });
      this.$emit('update:filter-value', { value: Object.values(checks) });
    },
  },
};
</script>
